import React, { useState, useEffect } from 'react';
import { BladeModal } from '@monavate/ui-core';
import styled from 'styled-components';
import { KeyValueViewer } from '@monavate/ui-core';
import { createSummaryObject } from './helper';
import { useDispatch, useSelector } from 'react-redux';
import { RootState } from '../../reduxStore/rootReducer';
import { closeIbanDetailsModal } from '@/reduxStore/slices/ibansSlice';

interface IbanDetailsBladeModalProps {
    isOpen: boolean;
}

const Header = styled.div`
    padding: 32px 32px 24px;
    background: ${(props) => props.theme['Surface/secondary']}
        /* TODO: check color. Alternatives: ["Surface/secondary","Interaction/hover","Interaction/active","Interaction/selected","Interaction/focus","Interaction/disabled"] */;
`;

const MainTitle = styled.div`
    color: ${(props) => props.theme['Content/primary']}
        /* TODO: check color. Alternatives: ["Content/primary","Content/logo","Content/on-accent"] */;
    font-family: 'Poppins', serif;
    font-size: 16px;
    font-style: normal;
    font-weight: 600;
    line-height: 24px;
`;

const BladeModalHeader = () => {
    return (
        <Header>
            <MainTitle>Top up credentials</MainTitle>
        </Header>
    );
};

const IbanDetailsBladeModal: React.FC<IbanDetailsBladeModalProps> = ({ isOpen }) => {
    const dispatch = useDispatch();
    const ibanToDisplay = useSelector((state: RootState) => state.ibans.ibanToDisplay);

    useEffect(() => {
        return () => {
            onCloseModalHandler();
        };
    }, []);

    const onCloseModalHandler = () => {
        dispatch(closeIbanDetailsModal());
    };

    return (
        <BladeModal
            isOpen={isOpen && !!ibanToDisplay}
            closeButton={true}
            handleClose={onCloseModalHandler}
            padding={'0 32px'}
            customHeader={<BladeModalHeader />}
        >
            <KeyValueViewer data={createSummaryObject(ibanToDisplay)} />
        </BladeModal>
    );
};

export default IbanDetailsBladeModal;
